import * as React from 'react';
import { Spinner } from '@/components/ui/spinner';

export default function backDrop({
  open,
  handleCloseBackDrop,
  background = false,
}) {
  if (!open) return null;

  return (
    <div
      className="absolute inset-0 flex items-center justify-center text-white"
      style={{
        zIndex: 1200,
        backgroundColor: background ? 'rgba(0, 66, 99, 0.1)' : 'transparent',
      }}
      onClick={handleCloseBackDrop}
    >
      <Spinner color="#ed6c02" size={40} />
    </div>
  );
}
